"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IpcBusReplier = void 0;
const serialize_error_1 = require("serialize-error");
const server_handshake_1 = require("../handshake/server-handshake");
const stringify_ipc_bus_service_1 = require("../ipc-bus-service/stringify-ipc-bus-service");
class IpcBusReplier {
    constructor(ipcBus, service) {
        this.service = service;
        this.ipcBus = new stringify_ipc_bus_service_1.StringifyIpcBusService(ipcBus);
        this.serverHandshake = new server_handshake_1.ServerHandshake(this.ipcBus);
    }
    async connect() {
        return this.ipcBus.connect();
    }
    handleRequest(channel, handler) {
        return this.ipcBus.subscribe(channel, async (innerChannel, msg) => {
            const requestMessage = msg;
            let busReplyMessage;
            try {
                const reply = await handler(requestMessage.content);
                busReplyMessage = {
                    correlationId: requestMessage.meta.correlationId,
                    reply,
                };
            }
            catch (err) {
                busReplyMessage = {
                    correlationId: requestMessage.meta.correlationId,
                    error: (0, serialize_error_1.serializeError)(err),
                };
            }
            this.ipcBus.publish(requestMessage.meta.replyTo, busReplyMessage);
        });
    }
    async start() {
        await this.serverHandshake.connect(this.service);
    }
    disconnect() {
        this.serverHandshake.disconnect();
    }
}
exports.IpcBusReplier = IpcBusReplier;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaXBjLWJ1cy1yZXBsaWVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3JlcGxpZXIvaXBjLWJ1cy1yZXBsaWVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLHFEQUFpRDtBQUVqRCxvRUFBZ0U7QUFFaEUsNEZBQXNGO0FBRXRGLE1BQWEsYUFBYTtJQUl0QixZQUFZLE1BQXFCLEVBQVUsT0FBZTtRQUFmLFlBQU8sR0FBUCxPQUFPLENBQVE7UUFDdEQsSUFBSSxDQUFDLE1BQU0sR0FBRyxJQUFJLGtEQUFzQixDQUFDLE1BQU0sQ0FBQyxDQUFDO1FBQ2pELElBQUksQ0FBQyxlQUFlLEdBQUcsSUFBSSxrQ0FBZSxDQUFDLElBQUksQ0FBQyxNQUFNLENBQUMsQ0FBQztJQUM1RCxDQUFDO0lBRU0sS0FBSyxDQUFDLE9BQU87UUFDaEIsT0FBTyxJQUFJLENBQUMsTUFBTSxDQUFDLE9BQU8sRUFBRSxDQUFDO0lBQ2pDLENBQUM7SUFFTSxhQUFhLENBQUMsT0FBZSxFQUFFLE9BQTJCO1FBQzdELE9BQU8sSUFBSSxDQUFDLE1BQU0sQ0FBQyxTQUFTLENBQUMsT0FBTyxFQUFFLEtBQUssRUFBRSxZQUFvQixFQUFFLEdBQW9CLEVBQUUsRUFBRTtZQUN2RixNQUFNLGNBQWMsR0FBeUIsR0FBMkIsQ0FBQztZQUV6RSxJQUFJLGVBQWUsQ0FBQztZQUVwQixJQUFJLENBQUM7Z0JBQ0QsTUFBTSxLQUFLLEdBQUcsTUFBTSxPQUFPLENBQUMsY0FBYyxDQUFDLE9BQU8sQ0FBQyxDQUFDO2dCQUVwRCxlQUFlLEdBQUc7b0JBQ2QsYUFBYSxFQUFFLGNBQWMsQ0FBQyxJQUFJLENBQUMsYUFBYTtvQkFDaEQsS0FBSztpQkFDUixDQUFDO1lBQ04sQ0FBQztZQUFDLE9BQU8sR0FBRyxFQUFFLENBQUM7Z0JBQ1gsZUFBZSxHQUFHO29CQUNkLGFBQWEsRUFBRSxjQUFjLENBQUMsSUFBSSxDQUFDLGFBQWE7b0JBQ2hELEtBQUssRUFBRSxJQUFBLGdDQUFjLEVBQUMsR0FBRyxDQUFDO2lCQUM3QixDQUFDO1lBQ04sQ0FBQztZQUVELElBQUksQ0FBQyxNQUFNLENBQUMsT0FBTyxDQUFDLGNBQWMsQ0FBQyxJQUFJLENBQUMsT0FBTyxFQUFFLGVBQWUsQ0FBQyxDQUFDO1FBQ3RFLENBQUMsQ0FBQyxDQUFDO0lBQ1AsQ0FBQztJQUtNLEtBQUssQ0FBQyxLQUFLO1FBQ2QsTUFBTSxJQUFJLENBQUMsZUFBZSxDQUFDLE9BQU8sQ0FBQyxJQUFJLENBQUMsT0FBTyxDQUFDLENBQUM7SUFDckQsQ0FBQztJQUtNLFVBQVU7UUFDYixJQUFJLENBQUMsZUFBZSxDQUFDLFVBQVUsRUFBRSxDQUFDO0lBQ3RDLENBQUM7Q0FDSjtBQWxERCxzQ0FrREMifQ==